module.exports = __webpack_public_path__ + "static/a-xx-220-art-dced34df8b3f8e4bad5c5de1437a8a95.jpg";